import React, { useState, useEffect } from 'react';
import './Header/Css/sideBar.css';
import PermissionServices from '../services/PermissionServices';

const menuItems = [
  { name: 'Dashboard', key: 'dashboard' },
  { name: 'User Manager', key: 'users' },
  { name: 'Home Slider', key: 'home-slider' },
  { name: 'Contact-Us', key: 'contact-us' },
  { name: 'Notification', key: 'notification' },
  { name: 'Plan', key: 'plan' },
  { name: 'Vendor Registration', key: 'vendor' },
  { name: 'Category', key: 'category' },
  { name: 'Service', key: 'service' },
  { name: 'Brand', key: 'brand' },
  { name: 'Add Vehicle', key: 'vehicle' },
  { name: 'Order List', key: 'order' },
  { name: 'Feedback', key: 'feedback' },
  { name: 'Add Addons', key: 'addons' },
  { name: 'Coupon Code Manager', key: 'coupon' },
  { name: 'Pages', key: 'pages' },
  { name: 'Settings', key: 'settings' },
];

const roles = ['User', 'Vendor', 'Helper'];

function UserPermission({ admin, closeModal }) {
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await PermissionServices.getPermission();
        const data = response.data;
        const formattedPermissions = data.reduce((acc, item) => {
          acc[item.menuItem] = item.roles;
          return acc;
        }, {});
        setPermissions(formattedPermissions);
      } catch (error) {
        console.error('Error loading permissions:', error);
        setError('Error loading permissions. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  const handleCheckboxChange = (menuItem, role) => {
    setPermissions(prevPermissions => ({
      ...prevPermissions,
      [menuItem]: {
        ...prevPermissions[menuItem],
        [role]: !prevPermissions[menuItem]?.[role]
      }
    }));
  };

  const handleSavePermissions = async () => {
    const formattedPermissions = Object.entries(permissions).map(([menuItem, roles]) => ({
      menuItem,
      roles
    }));

    try {
      await PermissionServices.savePermission({ permissions: formattedPermissions });
      alert('Permissions saved successfully');
      closeModal();
      // console.log('Permissions saved successfully');
    } catch (error) {
      console.error('Error saving permissions:', error);
      setError('Error saving permissions. Please try again.');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Permission</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <div className="user-permission-container">
                    {loading ? (
                      <p>Loading...</p>
                    ) : error ? (
                      <p>{error}</p>
                    ) : (
                      <>
                        <table className="user-permission-table">
                          <thead>
                            <tr>
                              <th>Menu Item</th>
                              {roles.map(role => (
                                <th key={role}>{role}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {menuItems.map(menuItem => (
                              <tr key={menuItem.key}>
                                <td>{menuItem.name}</td>
                                {roles.map(role => (
                                  <td key={role}>
                                    <input
                                      type="checkbox"
                                      checked={permissions[menuItem.key]?.[role] || false}
                                      onChange={() => handleCheckboxChange(menuItem.key, role)}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <button className="submit-green-btn" onClick={handleSavePermissions}>Apply</button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default UserPermission;
